const showParentTaskDataTypes = ["responseId", "status"];

export default showParentTaskDataTypes;
